import classNames from 'classnames';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import css from './style.module.scss';
type Props = {
  liffId: string;
  path?: string;
  hash?: string;
};

const LineMiniAppButtonLink: FC<Props> = ({ liffId, path, hash }) => {
  const intl = useIntl();
  const miniAppUrl = new URL('https://liff.line.me');
  const pathname = path ? liffId + path : liffId;
  miniAppUrl.pathname = pathname;
  if (hash) {
    miniAppUrl.hash = hash;
  }

  return (
    <div className={classNames(css.container)}>
      <a href={miniAppUrl.toString()} className={classNames(css.link_button)}>
        {intl.formatMessage({ id: 'lineMiniAppLinkButton.reserveByLine' })}
      </a>
    </div>
  );
};

export default LineMiniAppButtonLink;
